export const determineBgColor = (selected?: boolean, active?: boolean): string =>
  selected || active ? 'action-bg-neutral-weak-hover' : 'action-bg-neutral-weak-default';

export const determineSize = (small?: boolean): string => (small ? 'py-xxs! px-xs!' : '');
